/** Latest raise or decision time for desk list order (newest first). */

function toMs(value) {
  if (value == null || value === "") return 0;
  if (typeof value === "number") {
    if (!Number.isFinite(value) || value <= 0) return 0;
    return value < 1e12 ? value * 1000 : value;
  }
  const t = new Date(value).getTime();
  return Number.isNaN(t) ? 0 : t;
}

function trailActedMs(request) {
  const trail = Array.isArray(request?.workflowTrail)
    ? request.workflowTrail
    : Array.isArray(request?.workflowSteps)
      ? request.workflowSteps
      : [];
  let max = 0;
  for (const step of trail) {
    const st = String(step?.status || "").toLowerCase();
    if (
      st !== "approved" &&
      st !== "rejected" &&
      st !== "acknowledged" &&
      st !== "submitted"
    ) {
      continue;
    }
    const ms = toMs(step?.actedAt);
    if (ms > max) max = ms;
  }
  return max;
}

export function deskLatestActivityMs(request) {
  if (!request) return 0;
  const status = String(request.status || "").toLowerCase();
  const isApproved = status === "approved";
  // For approved requests, prioritize approval date over other activity times
  if (isApproved && request.lastDecision?.actedAt) {
    const approvalMs = toMs(request.lastDecision.actedAt);
    if (approvalMs > 0) {
      return Math.max(approvalMs, trailActedMs(request));
    }
  }
  return Math.max(
    toMs(request.submittedAt),
    toMs(request.createdAt),
    toMs(request.updatedAt),
    toMs(request.lastDecision?.actedAt),
    trailActedMs(request)
  );
}

export function sortDeskRequestsLatestFirst(list) {
  return [...(list || [])].sort(
    (a, b) => deskLatestActivityMs(b) - deskLatestActivityMs(a)
  );
}
